// extracted by mini-css-extract-plugin
export var bodyLocked = "Footer-module--body-locked--fea94";
export var consent = "Footer-module--consent--a50e2";
export var consentContent = "Footer-module--consent-content--65590";
export var footer = "Footer-module--footer--bb7a8";
export var footerLeft = "Footer-module--footer-left--e4c9a";
export var footerRight = "Footer-module--footer-right--df9da";